import React from "react";
import CheckItem from "../../../components/CheckItem";
import TableLogComponents from "../../../components/TableLogComponents";
export default function HistoryillnessTable() {
  return (
    <div className="box-table-history_illness">
      <TableLogComponents
        columns={[
          {
            title: <CheckItem callBack={(check) => {}} />,
            dataIndex: "check",
            key: "check",
          },
          {
            title: "First Name",
            dataIndex: "firstname",
            key: "firstname",
          },
          {
            title: "Last Name",
            dataIndex: "lastname",
            key: "lastname",
          },
          {
            title: "Symptom",
            dataIndex: "symptom",
            key: "symptom",
          },
          {
            title: "Drug",
            dataIndex: "drug",
            key: "drug",
          },
          {
            title: "Bed",
            dataIndex: "bed",
            key: "bed",
          },
          {
            title: "Date/Time",
            dataIndex: "datetime",
            key: "datetime",
          },
          {
            title: "ID",
            dataIndex: "id",
            key: "id",
          },
          {
            title: "Class",
            dataIndex: "class",
            key: "class",
          },
          {
            title: "Room",
            dataIndex: "room",
            key: "room",
          },
          {
            title: "Advisor",
            dataIndex: "advisor",
            key: "advisor",
          },
        ]}
        dataSource={[
          {
            check: (
              <div className="row-gab1">
                <CheckItem callBack={(check) => {}} />
                {"1"}
              </div>
            ),
            firstname: "firstname 1",
            lastname: "lastname 1",
            symptom: "Stomachache",
            drug: "Baclofen",
            bed: "-",
            datetime: "01/01/65 \n 15:50",
            id: "ID 1",
            class: "M5",
            room: "1",
            advisor: "T.Pattarapon",
          },{
            check: (
              <div className="row-gab1">
                <CheckItem callBack={(check) => {}} />
                {"2"}
              </div>
            ),
            firstname: "firstname 2",
            lastname: "lastname 2",
            symptom: "Stomachache",
            drug: "Baclofen",
            bed: "-",
            datetime: "01/01/65 \n 15:50",
            id: "ID 1",
            class: "M5",
            room: "1",
            advisor: "T.Pattarapon",
          },{
            check: (
              <div className="row-gab1">
                <CheckItem callBack={(check) => {}} />
                {"3"}
              </div>
            ),
            firstname: "firstname 3",
            lastname: "lastname 3",
            symptom: "Stomachache",
            drug: "Baclofen",
            bed: "-",
            datetime: "01/01/65 \n 15:50",
            id: "ID 1",
            class: "M5",
            room: "1",
            advisor: "T.Pattarapon",
          },{
            check: (
              <div className="row-gab1">
                <CheckItem callBack={(check) => {}} />
                {"4"}
              </div>
            ),
            firstname: "firstname 4",
            lastname: "lastname 4",
            symptom: "Stomachache",
            drug: "Baclofen",
            bed: "-",
            datetime: "01/01/65 \n 15:50",
            id: "ID 1",
            class: "M5",
            room: "1",
            advisor: "T.Pattarapon",
          },{
            check: (
              <div className="row-gab1">
                <CheckItem callBack={(check) => {}} />
                {"5"}
              </div>
            ),
            firstname: "firstname 5",
            lastname: "lastname 5",
            symptom: "Stomachache",
            drug: "Baclofen",
            bed: "-",
            datetime: "01/01/65 \n 15:50",
            id: "ID 1",
            class: "M5",
            room: "1",
            advisor: "T.Pattarapon",
          },{
            check: (
              <div className="row-gab1">
                <CheckItem callBack={(check) => {}} />
                {"6"}
              </div>
            ),
            firstname: "firstname 6",
            lastname: "lastname 6",
            symptom: "Stomachache",
            drug: "Baclofen",
            bed: "-",
            datetime: "01/01/65 \n 15:50",
            id: "ID 1",
            class: "M5",
            room: "1",
            advisor: "T.Pattarapon",
          },{
            check: (
              <div className="row-gab1">
                <CheckItem callBack={(check) => {}} />
                {"7"}
              </div>
            ),
            firstname: "firstname 7",
            lastname: "lastname 7",
            symptom: "Stomachache",
            drug: "Baclofen",
            bed: "-",
            datetime: "01/01/65 \n 15:50",
            id: "ID 1",
            class: "M5",
            room: "1",
            advisor: "T.Pattarapon",
          },{
            check: (
              <div className="row-gab1">
                <CheckItem callBack={(check) => {}} />
                {"8"}
              </div>
            ),
            firstname: "firstname 8",
            lastname: "lastname 8",
            symptom: "Stomachache",
            drug: "Baclofen",
            bed: "-",
            datetime: "01/01/65 \n 15:50",
            id: "ID 1",
            class: "M5",
            room: "1",
            advisor: "T.Pattarapon",
          },{
            check: (
              <div className="row-gab1">
                <CheckItem callBack={(check) => {}} />
                {"9"}
              </div>
            ),
            firstname: "firstname 9",
            lastname: "lastname 9",
            symptom: "Stomachache",
            drug: "Baclofen",
            bed: "-",
            datetime: "01/01/65 \n 15:50",
            id: "ID 1",
            class: "M5",
            room: "1",
            advisor: "T.Pattarapon",
          }
        ]}
      />
    </div>
  );
}
